(function () {
  'use strict';

  function boot(root) {
    if (root.getAttribute('data-yolo-bound') === '1') return;
    root.setAttribute('data-yolo-bound', '1');

    var track  = root.querySelector('[data-yolo-track]');
    var frames = [].slice.call(root.querySelectorAll('[data-yolo-frame]'));
    var dots   = [].slice.call(root.querySelectorAll('[data-yolo-dot]'));
    if (!track || frames.length < 2) return;

    var calm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    var current = -1;
    var ticking = false;

    function paint(i) {
      if (i === current) return;
      current = i;
      for (var n = 0; n < frames.length; n++) frames[n].classList.toggle('is-on', n === i);
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-on', d === i);
        dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
      }
    }

    function measure() {
      ticking = false;
      var r = track.getBoundingClientRect();
      var travel = track.offsetHeight - window.innerHeight;
      if (travel <= 0) { paint(0); return; }
      var t = (-r.top) / travel;
      t = t < 0 ? 0 : (t > 1 ? 1 : t);
      var idx = Math.min(frames.length - 1, Math.floor(t * frames.length));
      paint(idx);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    function enable() {
      if (calm && calm.matches) { root.classList.remove('is-ready'); paint(0); return; }
      root.classList.add('is-ready');
      measure();
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var travel = track.offsetHeight - window.innerHeight;
        if (travel <= 0) return;
        var y = track.offsetTop + (travel * (i + 0.5) / frames.length);
        window.scrollTo({ top: y, behavior: (calm && calm.matches) ? 'auto' : 'smooth' });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', onScroll);
    if (calm) {
      if (calm.addEventListener) calm.addEventListener('change', enable);
      else if (calm.addListener) calm.addListener(enable);
    }
    enable();
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-voro-yolo]')).forEach(boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
